<template>

	<anchor-container use-dot-nav>
		<template slot-scope="anchorData">
			<Layout mastheadBackground="pd/100001/kids_loop_1">
				<template slot="preHeadline">StudySync<mark>ELA</mark></template>
				<template slot="headline">A Comprehensive English<br />Language Arts Curriculum<br />for Grades 6-12</template>

				<template slot="nav">
					<SectionNav>
						<template slot="navTitle">StudySync<mark>ELA</mark></template>
						<template slot="navList">
							<ul>
								<li v-for="(component, key) in anchorData.anchors" :key="key">
									<anchor-link :to="key">{{component.title}}</anchor-link>
								</li>
							</ul>
						</template>
					</SectionNav>
				</template>

				<template slot="body">

					<anchor-content el="section" anchor="ela-curriculum" title="Curriculum">
						<SectionHeadline>
							<template slot="subHeadline">Best-in-Class</template>
							<template slot="headline">A living curriculum, with Rich multimedia and captivating resources added every day.</template>
							<template slot="content">StudySync is a complete ELA curriculum designed to meet the rigorous academic needs of today’s classroom. In print or online, StudySync is designed to engage every student, because every student deserves the same opportunity and access in the classroom.</template>
						</SectionHeadline>

						<ul class="video-group">
							<li v-for="v in videoGroup" :key="v.key" class="video-group__item" @click.prevent="$store.commit('app/setActiveVideoModal', v.action.video)">
								<figure class="video-group__image">
									<img :src="v.image">
								</figure>
								<div class="video-group__overlay">
									<h5 class="overlay__title">{{v.title}}</h5>
									<div class="overlay__action">
										<btn><a @click.prevent>{{v.action.title}}</a></btn>
									</div>
								</div>
							</li>
						</ul>

						<ImageTextCta>
							<template slot="image">
								<shadowed-image src="pd/100001/laptop_library" :shadow="imageGroups.laptop.shadow" position="bottom-center" type="video" />
							</template>
							<template slot="entrys">
								<CheckList>
									<template slot="listItems">
										<li>
											<h3>Integrated Reading & Writing</h3>
											<p>StudySync’s unique blend of contemporary and classic literature comes together with the program’s rigorous reading routines to dynamically instruct students toward mastery.</p>
										</li>
										<li>
											<h3>Embedded Skills Lessons</h3>
											<p>Skill lessons ensure students build foundational language and comprehension skills, as well as reading, writing, and research on inquiry skills every day.</p>
										</li>
										<li>
											<h3>English Language Learners (ELL)</h3>
											<p>Resources are organized around a first read, a close read, and an associated skill lesson. ELL skill lessons emphasize explicit vocabulary instruction, language acquisition, and reading comprehension.</p>
										</li>
									</template>
								</CheckList>
							</template>
						</ImageTextCta>
						<ImageTextCta class="reversed">
							<template slot="entrys">
								<CheckList>
									<template slot="listItems">
										<li>
											<h3>The Writing Process</h3>
											<p>Extended Writing Projects (EWPs) guide students through the process of writing multi-paragraph essays in a variety of forms. Explicit writing instruction through a combination of Writing Process and Skill lessons, guide students through the stages of Planning, Drafting, Revising, Editing, and Publishing.</p>
										</li>
										<li>
											<h3>Assessments</h3>
											<p>Self, peer, and teacher evaluations are embedded in every unit lesson to provide teachers a wide variety of short and longer cycle formative assessment options. End-of-unit summative assessments combine progress monitoring tools and targeted lessons for re-teaching and remediation to meet the needs of all learners.</p>
										</li>
										<li>
											<h3>Peer Review</h3>
											<p>Our peer review platform creates a community of writers giving students an authentic audience to provide immediate feedback every time they write. Anonymous peer review helps build students into skilled writers and critical thinkers.</p>
										</li>
									</template>
								</CheckList>
							</template>
							<!-- <template slot="cta">
								<btn class="fit"><a href="#">More About Peer Reviews</a></btn>
							</template> -->
							<template slot="image"><img src="~img/ela/phone-peer-review-full.jpg"></template>
						</ImageTextCta>
						<!--<ImageTextCta>
							<template slot="image">
								<p style="font-size: 1.9rem; line-height: 1.72; font-weight: 300; color: #6D6E71; padding-top:12px;"><span style="color:#3D3D3D; font-weight:600;">Dr. Michelle H. Martin</span><br />
								Dr. Michelle H. Martin is the Beverly Cleary Endowed Professor for Children and Youth Services in the Information School at the
								University of Washington and from 2011 to 2016 was the inaugural Augusta Baker Endowed Chair in Childhood Literacy at the
								University of South Carolina. She published Brown Gold: Milestones of African-American Children’s Picture Books, 1845–2002
								(Routledge, 2004), and is the founder of Read-a-Rama, a nonprofit that uses children’s books as the springboard for year-round and
								summer camp programming.<br /><br /><span style="color:#3D3D3D; font-weight:600;">Dr. Douglas Fisher</span><br />Dr. Douglas Fisher is Professor of Educational Leadership at San Diego State University and a teacher leader at Health Sciences High &amp; Middle College, having been an early intervention teacher and elementary school educator. He is the recipient of a Christa McAuliffe award for excellence in teacher education and is a member of the California Reading Hall of Fame. He is a renowned speaker and author of numerous articles and books and is President of the International Literacy Association (ILA) Board.<br /><br /><br />
								</p>
							</template>
							<template slot="entrys">
								<h3>Curriculum Authors</h3>
								<p><span style="color:#3D3D3D; font-weight:600;">Dr. Timothy Shanahan</span><br />Dr. Timothy Shanahan is Distinguished Professor Emeritus at the University of Illinois at Chicago, where he is Founding Director of the UIC Center for Literacy. He was Director of Reading for Chicago Public Schools, and, among other awards, received the William S. Gray Citation for Lifetime Achievement and the Albert J. Harris Award for outstanding research on reading disability from the International Literacy Association (ILA). He is the author/editor of more than 200 publications and books, and his research emphasizes the connections between learning to read and learning to write, literacy in the disciplines, and improvement of reading achievement.<br /><br />
								<span style="color:#3D3D3D; font-weight:600;">Catlin Tucker</span><br />
								Catlin Tucker is a Google Certified Innovator, bestselling author, international trainer, and frequent Edtech speaker, who teaches
								in Sonoma County, where she was named Teacher of the Year in 2010. Her books Blended Learning in Grades 4–12 and Blended
								Learning In Action are both bestsellers. She is currently in the doctoral program at Pepperdine University, and writes the Techy
								Teacher column for ASCD’s Educational Leadership.</p>
							</template>
						</ImageTextCta>-->
					</anchor-content>

					<anchor-content el="section" anchor="ela-media" title="Media">
						<SectionHeadline class="centered">
							<template slot="subHeadline">Unparalleled Media</template>
							<template slot="headline">Introducing StudySyncTv and More</template>
							<template slot="content">Consuming media in the classroom is never a passive pursuit. Our media is carefully designed to amplify student voices, foster collaboration, and elevate the level of academic discourse.</template>
						</SectionHeadline>
						<!--	<VideoSlider>
							<template slot="sliderItems">
								<li>
									<h3>StudySyncTV</h3>
									<p>A better way to learn how to critically analyze a difficult text</p>
								</li>
								<li class="active">
									<h3>Group Discussions</h3>
									<p>Our StudySyncTV episodes show students how to participate in a critical discussion of literature, how to support their viewpoint with text evidence, and how to skillfully use academic vocabulary – all while collaborating with their peers.</p>
								</li>
								<li>
									<h3>Award Winning Media</h3>
									<p>Professional, short study lessons of collaborating peers</p>
								</li>
							</template>
							<template slot="video">
								<button><img src="~img/play.png"></button>
								<shadowed-image :src="imageGroups.videoTablet.img" :shadow="imageGroups.videoTablet.shadow" position="" />
							</template>
						</VideoSlider> -->
						<ImageTextCta>
							<template slot="image"><img src="~img/ela/barrio.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', { src: 'lesson/185/sync_tv', cc: true })"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h3>StudySyncTV</h3>
								<p>What better way to learn how to critically analyze a difficult text than to watch a model of students doing just that?  Our StudySyncTV episodes show students how to participate in a critical discussion of literature, how to support their viewpoint with text evidence, and how to skillfully use academic vocabulary – all while collaborating with their peers. </p>
							</template>
						</ImageTextCta>
						<ImageTextCta class="reversed">
							<template slot="image"><img src="~img/ela/sync-skills1.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', { src: 'skills/2910/video', cc: true })"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h3>SkillsTV</h3>
								<p>Imagine having hundreds of skills lessons available in a click. That’s what StudySync provides. Using peer-to-peer instruction, SkillsTV episodes provide an explanation and a model for key literary skills, including plot, theme, character development, tone, setting and more!</p>
							</template>
						</ImageTextCta>
						<ImageTextCta>
							<template slot="image"><img src="~img/ela/analyzing.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', { src: 'define/858/video', cc: true })"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h3>Concept Definitions</h3>
								<p>Each skill lesson includes a Concept Definition video where students define and break down the key components of a skill or strategy. Concept Definition videos put student voices front and center to introduce key concept vocabulary. These videos always feature a cast of students that reflect and inspire classroom audiences.</p>
							</template>
						</ImageTextCta>
						<ImageTextCta class="reversed">
							<template slot="image"><img src="~img/ela/preview.jpg"></template>
							<template slot="action">
								<button @click.prevent="$store.commit('app/setActiveVideoModal', { src: 'library/575/preview', cc: true })"><img src="~img/play.png"></button>
							</template>
							<template slot="entrys">
								<h3>Previews</h3>
								<p>Watch how StudySync’s movie-like Previews open the doors to great literature by providing context and intrigue to diverse texts from all genres.</p>
							</template>
						</ImageTextCta>
					</anchor-content>

					<anchor-content el="section" anchor="ela-library" title="Library" class="overflow-visible">
						<Parallax v-if="!$mq.mobile" :src="bgImages.classRoomRecording" class="parallax-banner" />
						<SectionHeadline>
							<template slot="subHeadline">Ever-Growing Resources</template>
							<template slot="headline">Connecting with Literature Through Technology</template>
							<template slot="content">Take advantage of StudySync's vast, ever-growing digital library of over a thousand classic and contemporary, fiction, and non-fiction selections. Students and teachers can access diverse characters and points-of-view through in-depth studies of texts at levels of complexity and bring the literature to life with additional video content added throughout the year.</template>
						</SectionHeadline>
						<LibraryShowcase class="showcase">
							<li>
								<figure>
									<img src="~img/carousel/moby.jpg">
								</figure>
								<figure>
									<img src="~img/carousel/hatchet.jpg">
								</figure>
							</li>
							<li>
								<figure>
									<img src="~img/carousel/dangerous.jpg">
								</figure>
								<figure>
									<img src="~img/carousel/ethiopia.jpg">
								</figure>
							</li>
							<li>
								<figure>
									<img src="~img/carousel/postmaster.jpg">
								</figure>
								<figure>
									<img src="~img/carousel/handmaid.jpg">
								</figure>
							</li>
							<li>
								<figure>
									<img src="~img/carousel/barrio1.jpg">
								</figure>
								<figure>
									<img src="~img/carousel/monkey.jpg">
								</figure>
							</li>
							<li>
								<figure>
									<img src="~img/carousel/slave.jpg">
								</figure>
								<figure>
									<img src="~img/carousel/babylon.jpg">
								</figure>
							</li>
						</LibraryShowcase>
						<ImageTextCta >
							<template slot="image"><img src="~img/ela/ela-more-about-blast3.jpg"></template>
							<template slot="entrys">
								<h3>StudySync Blasts Engage Students with the Most Important Issues in the World Today</h3>
								<p>StudySync Blasts capture students’ imaginations with short read / write assignments addressing real world topics. Whether the topic is the recent decline of the honeybee population, the impact of Brexit on the chocolate trade, or the relationship  between social media and our social lives,  Blasts provide a social learning experience that builds reading, writing and research skills on a platform mediated by teachers.</p>
							</template>
							<!-- <template slot="cta">
								<btn class="fit"><a href="#">More About Blasts</a></btn>
							</template> -->
						</ImageTextCta>
						<ImageTextCta class="reversed">
							<template slot="image"><img src="~img/ela/ela-responsive-platform.png"></template>
							<template slot="entrys">
								<h3>StudySync's Ever-Growing, Ever-Enhanced, Responsive Platform</h3>
								<p>Technology is ever-evolving. No one downloads an app or computer program without having access to improvements and updates. It’s the same with StudySync. As new opportunities for better instruction, assessment, and student collaboration become available, we offer them directly to you.</p>
							</template>
						</ImageTextCta>
					</anchor-content>

					<anchor-content el="section" anchor="ela-access" title="Access">
						<SectionHeadline>
							<template slot="subHeadline">Differentiation</template>
							<template slot="headline">Reaching every Student</template>
						</SectionHeadline>
						<ImageTextCta class="image-full">
							<template slot="entrys">
								<CheckList>
									<template slot="listItems">
										<li>
											<h3>Scaffolds</h3>
											<p>StudySync is setting the standard for what differentiation looks like. Our scaffolds allow for every student in a class to work on the same assignment. We provide the appropriate support for every learner – be it language summaries or sentence frames.</p>
										</li>
										<li>
											<h3>Accessibility</h3>
											<p>StudySync is constructed to support students with disabilities, providing a high-contrast interface, screen-reader support and use of the product without a mouse.</p>
										</li>
									</template>
								</CheckList>
							</template>
							<template slot="image">
								<!-- <shadowed-image :src="imageGroups.videoTabletBottom.img" :shadow="imageGroups.videoTabletBottom.shadow" position="bottom-center" /> -->
								<img src="~img/ela/laptop-to-use3.png">
							</template>
						</ImageTextCta>
					</anchor-content>

				</template>

				<template slot="footer">
					<FooterCTA />
				</template>
			</Layout>
		</template>
	</anchor-container>

</template>

<script>
	import Layout from '@/components/Products/layout'
	import MastheadVideo from '@/components/Products/MastheadVideo'
	import SectionNav from '@/components/Products/SectionNav'
	import SectionHeadline from '@/components/Products/SectionHeadline'
	import ImageTextCta from '@/components/Products/ImageTextCta'
	import CheckList from '@/components/Products/CheckList'
	import LibraryShowcase from '@/components/LibraryShowcase'
	import FooterCTA from '@/components/FooterCTA'
	import ShadowedImage from '@/components/ShadowedImage'
	import Parallax from '@/components/Parallax'
	import { AnchorContainer, AnchorContent, AnchorLink } from '@/components/AnchorNav'

	export default {
		metaInfo () {
			return this.$generateMetaInfo({
				title: `StudySync ELA`,
				description: `StudySync is a complete ELA curriculum designed to meet the rigorous academic needs of today's classroom. In print or online, StudySync is designed to engage every student, because every student deserves the same opportunity and access in the classroom, regardless of his or her native language, learning level or physical, social and emotional ability.`,
				image: 'https://www.studysync.com/static/hiali.jpg'
			})
		},
		components: { Layout, MastheadVideo, SectionNav, SectionHeadline, ImageTextCta, CheckList, LibraryShowcase, FooterCTA, ShadowedImage, Parallax, AnchorContent, AnchorContainer, AnchorLink },
		data () {
			return {
				linearGradientStyle: "linear-gradient(to top, rgba(0, 0, 0, 1) 8%, rgba(0, 0, 0, .8) 16%, rgba(0, 0, 0, .7) 24%, rgba(0, 0, 0, .5) 32%, rgba(0, 0, 0, .3) 40%, rgba(0, 0, 0, 0))",
				bgImages: {
					mastheadEla: require('@/assets/img/ela/ela-masthead.jpg'),
					classRoomRecording: require('@/assets/img/ela/class-room-recording1.jpg')
				},
				imageGroups: {
					laptop: {
						img: require('@/assets/img/ela/laptop-ela.jpg'),
						shadow: require('@/assets/img/shadow-left-to-right.svg')
					},
					cellphone: {
						img: require('@/assets/img/ela/cellphone-ela.jpg'),
						shadow: require('@/assets/img/ela/shadow-cellphone.jpg')
					},
					videoTablet: {
						img: require('@/assets/img/ela/tablet-video-ela.png'),
						shadow: require('@/assets/img/shadow-left-to-right.svg')
					},
					videoTabletBottom: {
						img: require('@/assets/img/ela/laptop-to-use.png'),
						shadow: require('@/assets/img/shadow-left-to-right.svg')
					}
				},
				videoGroup: [
					{
						key: "literacyToLife",
						category: "video",
						title: "Dr. Doug Fisher on StudySync",
						image: require('@/assets/img/ela/video-group/7.jpg'),
						action: {
							title: "Watch Video",
							video: "pd/100001/dfshort"
						}
					},
					{
						key: "relevantFlexible",
						category: "video",
						title: "Relevant for Students. Flexible for Teachers",
						image: require('@/assets/img/ela/video-group/9.jpg'),
						action: {
							title: "Watch Video",
							video: "pd/100001/UnlockNewWorld"
						}
					},
					{
						key: "whatIf",
						category: "video",
						title: "What if your program was StudySync?",
						image: require('@/assets/img/ela/video-group/8.jpg'),
						action: {
							title: "Watch Video",
							video: "pd/100001/What_If_StudySync_960"
						}
					}
				]
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import "list-style-reset";
	@import "responsive-font";
	@import "media.scss";

	section {
		overflow:hidden;
		.overflow-visible {
			overflow:visible;
		}
	}

	.parallax-banner {
		height:70vh; background:transparent; margin-top:-5vw; margin-bottom:5vw;
	}

	.library-showcase.showcase {
		margin-top:5vw;
		padding-bottom:5vw;
	}

	.video-group {
		@include list-style-reset;
		margin:1em 0;
		@include media(large) {
			display:flex; flex-direction:row;
		}

		&__item {
			position:relative; cursor:pointer;
			@include media(large) {
				width:percentage(1/3);
			}
		}

		&__image {
			img {
				display:block;
			}
		}

		&__overlay {
			position:absolute; top:0; bottom:0; left:0; right:0; background:linear-gradient(rgba(#000, 0) 60%, rgba(#000, 1)); color:#fff; display:flex; align-items:center; flex-direction:column; justify-content:flex-end; padding:0 3em 1.5em; text-align:center;
			.overlay {
				&__title {
					@include responsive-font(18);
					font-family:"oswald", sans-serif; font-weight:400; text-transform:uppercase; line-height:1.66; margin: .05em 0;
				}
				&__action {
					@include media(large) {
						max-height:0; overflow:hidden; transition:all .5s ease;
					}
				}
			}
			&:hover {
				.overlay__action {
					@include media(large) {
						max-height:100%;
					}
				}
			}
		}

	}

</style>



// WEBPACK FOOTER //
// src/routes/products/ela.vue